module.exports = __webpack_public_path__ + "img/ai.1334111c.svg";